
import { Brain, Heart, Leaf, Sparkles } from "lucide-react";

const differentials = [
  {
    icon: Brain,
    number: "01",
    title: "Entende o porquê da sua alimentação",
    description: "Olhamos além do prato. Entendemos seus gatilhos emocionais, sua rotina e sua relação com a comida para criar uma estratégia que funcione de verdade.",
  },
  {
    icon: Heart,
    number: "02",
    title: "Sem dietas radicais ou julgamentos",
    description: "Cada paciente tem sua história. Respeitamos seu ritmo e criamos um plano que cabe na sua vida, sem culpa e sem proibições desnecessárias.",
  },
  {
    icon: Leaf,
    number: "03",
    title: "Ciência aplicada ao dia a dia",
    description: "Cada orientação tem base científica e é adaptada para ser prática. Você aprende a se alimentar bem de forma sustentável, não apenas durante o tratamento.",
  },
  {
    icon: Sparkles,
    number: "04",
    title: "Acompanhamento real e contínuo",
    description: "Não desaparecemos depois da consulta. O suporte é contínuo para garantir que você mantenha o progresso e supere os momentos difíceis.",
  },
];

export function Approaches() {
  return (
    <section className="py-24 bg-brand-primary relative overflow-hidden">
      {/* Decorações de fundo */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/3 rounded-full translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-brightGreen/10 rounded-full -translate-x-1/2 translate-y-1/2" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-px h-full bg-white/5" />

      <div className="container mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <p className="text-brand-softYellow font-bold text-sm uppercase tracking-widest font-primary mb-3">
            Por que funciona
          </p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white font-primary leading-tight mb-4">
            Uma abordagem que respeita{" "}
            <span className="title-special text-brand-softYellow text-5xl md:text-6xl">você</span>
          </h2>
          <p className="text-white/60 text-lg font-primary font-light leading-relaxed">
            A diferença entre mais uma dieta fracassada e uma transformação real está na abordagem.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-6">
          {differentials.map((item, i) => (
            <div
              key={i}
              className="group bg-white/8 hover:bg-white/12 border border-white/10 hover:border-white/20 rounded-2xl p-8 transition-all duration-300"
            >
              <div className="flex items-start gap-5">
                <div className="flex-shrink-0">
                  <span className="title-special text-5xl text-white/15 leading-none block">{item.number}</span>
                </div>
                <div>
                  <div className="w-10 h-10 bg-brand-softYellow/15 rounded-xl flex items-center justify-center mb-4">
                    <item.icon className="w-5 h-5 text-brand-softYellow" />
                  </div>
                  <h3 className="text-white font-bold font-primary text-lg mb-2 leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-white/60 font-primary font-light text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
